import { render, staticRenderFns } from "./page-router.vue?vue&type=template&id=45cde620&scoped=true"
import script from "./page-router.vue?vue&type=script&lang=js"
export * from "./page-router.vue?vue&type=script&lang=js"
import style0 from "./page-router.vue?vue&type=style&index=0&id=45cde620&prod&scoped=true&lang=scss"
import style1 from "./page-router.vue?vue&type=style&index=1&id=45cde620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cde620",
  null
  
)

export default component.exports